"use strict";

var _interopRequireDefault = require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _Edit = _interopRequireDefault(require("../../components/Book/Edit.vue"));

var _followBook = require("../../api/followBook");

var _collection = require("../../utils/collection");

//
//
//
//
//
//
//
//
var _default = {
  name: 'BookCreate',
  components: {
    BookEdit: _Edit.default
  },
  data: function data() {
    return {
      loading: false,
      data: {
        // 图书信息
        resourceOpenId: undefined,
        title: undefined,
        sectionCode: undefined,
        subjectCode: undefined,
        gradeCode: undefined,
        editionCode: undefined,
        volumeCode: undefined,
        periodCode: undefined,
        followUpBookType: '课内',
        category: undefined,
        state: 1,
        resourceType: 7
      }
    };
  },
  computed: {
    bookListStyle: function bookListStyle() {
      return {
        height: "".concat(this.$store.state.app.availableHeight, "px")
      };
    },
    // 控制页面高度
    openId: function openId() {
      return this.$route.params.openId;
    } // 要编辑的图书 open id

  },
  mounted: function mounted() {
    this.getData();
  },
  methods: {
    getData: function () {
      var _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$readBook, message;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0, _followBook.readBook)(this.openId);

              case 3:
                _yield$readBook = _context.sent;
                this.data = _yield$readBook.data;
                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                message = _context.t0.message;
                this.$notify.error({
                  title: '错误',
                  message: message
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }(),
    onSubmit: function () {
      var _onSubmit = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var data, message;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // 保存图书
                this.loading = true;
                _context2.prev = 1;
                data = (0, _collection.strictTrim)(this.data, ['title', 'category']); // 如果标题和分类是无效的字符串，设置为 undefined

                if (data.followUpBookType === '课内') {
                  data.category = '';
                } // 课内书没有分类


                _context2.next = 6;
                return (0, _followBook.updateBook)(this.data.resourceOpenId, data);

              case 6:
                this.$router.back();
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](1);
                message = _context2.t0.message;
                this.$notify.error({
                  title: '错误',
                  message: message
                });

              case 13:
                _context2.prev = 13;
                this.loading = false;
                return _context2.finish(13);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 9, 13, 16]]);
      }));

      function onSubmit() {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }(),
    goBack: function goBack() {
      this.$router.back();
    }
  }
};
exports.default = _default;